module.exports = __webpack_public_path__ + "img/icon-school2.fc6d3399.png";